import { useAuth } from "@/lib/auth-context";
import { Navigate, Outlet } from "react-router-dom";

type Role = "owner" | "admin" | "member";

/** Hides children unless the user has the required role. */
export function RequireRole({
  allow,
  children,
}: {
  allow: Role[];
  children?: React.ReactNode;
}) {
  const { user, status } = useAuth();
  if (status === "loading") return null;
  if (!user) return <Navigate to="/login" replace />;
  const role = (user.role || "member") as Role;
  if (!allow.includes(role)) {
    return <Navigate to="/app" replace state={{ deniedReason: "admin_required" }} />;
  }
  return children ? <>{children}</> : <Outlet />;
}
